<template>
  <section class="lk-step">
    <h2 class="lk-q">Wann hast du Geburtstag?</h2>
    <p class="lk-sub">
      Du musst mindestens 18 Jahre alt sein, um Viluu zu nutzen. Dein genaues Datum bleibt
      privat — auf dem Profil erscheint nur dein Alter.
    </p>
    <div
      class="dob-row"
      role="group"
      aria-label="Dein Geburtsdatum"
    >
      <input
        ref="dobDay"
        type="text"
        class="signup-input"
        :class="{ error: ageHint.error }"
        :value="day"
        placeholder="TT"
        maxlength="2"
        inputmode="numeric"
        aria-label="Tag"
        @input="onDobInput($event, 'day', 'dobMonth')"
      />
      <input
        ref="dobMonth"
        type="text"
        class="signup-input"
        :class="{ error: ageHint.error }"
        :value="month"
        placeholder="MM"
        maxlength="2"
        inputmode="numeric"
        aria-label="Monat"
        @input="onDobInput($event, 'month', 'dobYear')"
      />
      <input
        ref="dobYear"
        type="text"
        class="signup-input"
        :class="{ error: ageHint.error }"
        :value="year"
        placeholder="JJJJ"
        maxlength="4"
        inputmode="numeric"
        aria-label="Jahr"
        @input="onDobInput($event, 'year', null)"
      />
    </div>
    <div
      class="age-hint"
      :class="{ ok: ageHint.ok, bad: ageHint.bad }"
    >
      <span
        class="ah-ico"
        aria-hidden="true"
      >
        <svg
          class="ah-info"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2.2"
          stroke-linecap="round"
        >
          <circle
            cx="12"
            cy="12"
            r="9"
          />
          <path d="M12 16.5v-5M12 8h.01" />
        </svg>
        <svg
          class="ah-ok"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="3"
          stroke-linecap="round"
          stroke-linejoin="round"
        >
          <path d="M4.5 12.5l5 5L19.5 7" />
        </svg>
        <svg
          class="ah-bad"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2.4"
          stroke-linecap="round"
        >
          <path d="M12 6.5v7" />
          <path d="M12 17.6v.01" />
        </svg>
      </span>
      <span>{{ ageHint.text }}</span>
    </div>
  </section>
</template>

<script>
import { funnelAgeHint } from '../kennenlernenLeadFunnel';

export default {
  name: 'LeadFunnelStepBirthday',
  props: {
    day: { type: String, default: '' },
    month: { type: String, default: '' },
    year: { type: String, default: '' },
  },
  computed: {
    ageHint() {
      return funnelAgeHint({ day: this.day, month: this.month, year: this.year });
    },
  },
  methods: {
    onDobInput(event, field, nextRef) {
      const val = event.target.value.replace(/\D/g, '');
      if (event.target.value !== val) {
        event.target.value = val;
      }
      this.$emit('update:' + field, val);
      const maxLen = field === 'year' ? 4 : 2;
      if (val.length >= maxLen && nextRef && this.$refs[nextRef]) {
        this.$refs[nextRef].focus();
      }
    },
  },
};
</script>
